export default __webpack_public_path__ + "static/media/banner.68b2738f.png";